import { first } from 'lodash';

export const visibleColumnFunc = (columns) => {
	const visibleColumn = {};
	columns?.forEach((column) => {
		if (column?.isVisible === false) {
			visibleColumn[column?.accessorKey ?? column?.id] = false;
		} else {
			visibleColumn[column?.accessorKey ?? column?.id] = true;
		}
	});

	return visibleColumn;
};

export const piningColumnFunc = (columns) => {
	const pinedColumns = {};
	const firstColumnId = first(columns)?.accessorKey ?? first(columns)?.id;

	pinedColumns['left'] = [firstColumnId];
	pinedColumns['right'] = ['edit'];

	return pinedColumns;
};

export const enhanceColumnsWithFiltering = (columns) => {
	// console.log('columns', columns);
	return columns.map((column) => {
		// Create a copy to avoid modifying the original objects
		const enhancedColumn = { ...column };

		// Ensure filtering is properly enabled
		enhancedColumn.enableColumnFilter = true;

		// For text columns, explicitly define the filter function
		if (enhancedColumn.dataType?.toLowerCase() === 'text') {
			enhancedColumn.filterFn = 'includesString';
		}

		return enhancedColumn;
	});
};

export const getCommonPinningStyles = (column, type) => {
	const isPinned = column.getIsPinned();

	const styles = {
		width: column.getSize(),
	};

	if (column.id === 'Selection' && type === 'body') styles['padding'] = 0;
	if (isPinned) styles['zIndex'] = type === 'header' ? 3 : 1;
	if (isPinned) styles['position'] = 'sticky';
	// if (isLastLeftPinnedColumn) styles["boxShadow"] = "-3px 0 4px -4px gray inset";
	// if (isFirstRightPinnedColumn) styles["boxShadow"] = "3px 0 4px -4px gray inset";
	if (isPinned === 'left') styles['left'] = `${column.getStart('left')}px`;
	if (isPinned === 'right') styles['right'] = `${column.getAfter('right')}px`;
	if (type === 'body') styles['background'] = '#ffffff';

	return styles;
};
